import $ from 'jquery';

import './modules/Preloader';
import './modules/Accessability';
import './modules/OnInitPage';
import './modules/StickyButton';
import './modules/Select';
import './modules/FadeInOut';
import './modules/AskQuestionBanner';
import './modules/Inputs';
import './modules/Tabs';
import './modules/ScrollToAnchor';
import './modules/ScrollTop';
import './modules/Map';
import './modules/Publications';
import './modules/Gallery';
import './modules/Slider';
import './modules/Header';
import './modules/ToggleContent';
import './modules/HumanModel';
import './modules/TextPage';
import './modules/Aside';
import './modules/InitThumbsSwiper';
import './modules/StarRating';
import './modules/ImagesListCount';
import './modules/ScrollToAnchorWithAnimate';
import './modules/ShowMore';
import './modules/BaseSelect';
import './modules/Datepicker';
import './modules/DatepickerButton';
import './modules/TabsDatepicker';
import './modules/AppointmentTabsDatepicker';
import './modules/EmployeeAppointmentForm';
import './modules/IMask';
import './modules/ChoiceDateTimeForm';
import './modules/AppointmentChoiceDateTimeForm';
import './modules/AppointmentContacts';
import './modules/CookieNotification';
import './modules/YandexGoal';
import './modules/CertificateSliderThumbs';
import './modules/LottieAnimations';
import './modules/SpecialistsFilters';
import './modules/ScrollToAnchorBySelect';
import './modules/ToggleVisisbilityEmployeeCards';
import { initTurboForm } from './lib/TurboForm';

window.jQuery = $;

let forms = $('.js-form');

forms.each(function(i, item) {
    initTurboForm(item);
});

window.addEventListener('message', function(e) {
    if (e.origin !== 'https://lk.clinsev.ru') return;
    window.location = 'https://lk.clinsev.ru';
});

const iframePopup = document.querySelector('.make-appointment-modal.black-modal');
const mut = new MutationObserver(function(mutationRecords) {
    const popup = mutationRecords[0].target;
    const iframe = popup.querySelector('iframe');
    if (popup.classList.contains('active')) {
        iframe.setAttribute('src', 'https://lk.clinsev.ru');
    } else {
        iframe.removeAttribute('src');
    }
});

mut.observe(iframePopup, {
    attributeFilter: ['class']
});

/*
document.querySelector('.js_callback').addEventListener('click', (e) => {
    const callback_modal = e.target.closest('.callback-container').querySelector('.callback-container__overlay');
    callback_modal.classList.add('visible');
});

document.querySelector('.callback-container__overlay').addEventListener('click', (e) => {
    e.target.classList.remove('visible');
});

document.querySelector('.callback-container__overlay .btn--close').addEventListener('click', (e) => {
    e.target.closest('.callback-container__overlay').classList.remove('visible');
});
*/
